import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaSplit'
})
export class CommaSplitPipe implements PipeTransform {
    transform(value: string | null): string[] {
        if (!value) return [];
        return value.split(',').filter(item => item.trim().length > 0);
    }
}
